import { useNavigate } from 'react-router-dom';
import { BASE_PATH } from '../Constants/constants';
import { useCurrentUser } from './useCurrentUser';

export const useDashboardNavigate = () => {
  const navigate = useNavigate();
  const loggedInUser = useCurrentUser();

  const navigateTo = (path: string) => {
    navigate(`/${BASE_PATH}/${loggedInUser.id}/${path}`);
  };

  return navigateTo;
};
